module.exports = __webpack_public_path__ + "static/media/feedback-1.606203a3.png";